import React, { useMemo, useState } from 'react';
import { t } from 'i18next';
import { useNavigate } from 'react-router-dom';
import DataGridWrapper from '@/core/wrappers/data-grid-wrapper';
import { accountRetailerSupplierLocationService } from '@/projects/platform/services/account-retailer-supplier-location-service';
import { createCustomStore } from '@/core/wrappers/custom-store-wrapper';

const App = () => {
    const navigate = useNavigate();
    const [mainStore] = useState(() => createCustomStore({
        key: ['supplierAccountId', 'reatilerLocationCode'],
        load: accountRetailerSupplierLocationService.listRetailerSupplierLocations,
        byKey: (key, loadOptions) => {
            if (key) {
                loadOptions.filter = [["SupplierAccountId", "=", key.supplierAccountId], "and", ["SupplierAccountId", "=", key.reatilerLocationCode]];
            }
        },
    }));

    const goToImport = async () => {
        navigate(`/retailer-supplier-location-import`)
    }

    const importToExcelBtnOptions = useMemo(() => ({
        text: t('import'),
        type: 'normal',
        icon: 'import',
        onClick: goToImport
    }), []);
    return (

        <React.Fragment>

            <DataGridWrapper
                props={{ id: 'retailer-supplier-location-list' }}
                permissonCode='Retailer.SupplierLocation'
                datasource={mainStore}
                editingConfig={{ mode: 'row', useIcons: true }}
                filterVisible={true}
                headerFilterVisible={true}
                pagerVisible={true}
                grouping={true}
                enableCustomToolbarContent={true}
                isAddNewBtn={false}
                columns={[
                    {
                        dataField: 'supplierAccountId',
                        caption: t('supplier_account_id'),
                        dataType: 'string',
                        allowFiltering: true,
                        visible: false,
                    },
                    {
                        dataField: 'supplierAccountCode',
                        caption: t('supplier_account_code'),
                        dataType: 'string',
                        allowFiltering: true,
                        visible: false,
                    },
                    {
                        dataField: 'retailerName',
                        caption: t('retailer'),
                        dataType: 'string',
                        groupIndex: 0,
                    },
                    {
                        dataField: 'reatilerLocationCode',
                        caption: t('retailer_location_code'),
                        dataType: 'string',
                        allowFiltering: true,
                    },
                    {
                        dataField: 'retailerLocationName',
                        caption: t('retailer_location_name'),
                        dataType: 'string',
                        allowFiltering: true,
                    },
                    {
                        dataField: 'matchingLocationCode',
                        caption: t('matching_location_code'),
                        dataType: 'string',
                        allowFiltering: true,
                    },
                ]}

                customToolbarItems={[
                    {
                        widget: "dxButton",
                        location: "after",
                        options: importToExcelBtnOptions
                    }
                ]}
            />

        </React.Fragment>


    );
};

export default App;